export default {
  bba: {
    default: 'B.B.A.',
    slogan: 'Partenaire de vos déplacements professionnels',
    contact: 'Antoine Clapeau',
    tel1: '0149215598',
    tel2: '0680996276',
    telPrefix: '33',
    mail: 'nroger@teicee.com'
  }
}
